import { React } from 'mcelroy-lib'
import { CardPage, Button } from 'mcelroy-components'

export function LicensePage() {
    return (
        <CardPage title="McElroy License Agreement" size="lg">
            <div style={{backgroundColor: 'lightBlue'}}>Read the following terms and conditions carefully before setting up or
                using this account. Setting up and/or using ths account indicates your acceptance of these terms and
                conditions. If you do not agree with these terms and conditions, do not set up or use this account.
            </div>

            <h2>License Agreement</h2>

            <h3>Revised August 1, 2013</h3>

            <p>This is a legal agreement between you and McElroy Manufacturing, Inc. ("Licensor"). By setting up or
                using this account (the "Account"), you are consenting to the terms of this license agreement
                ("Agreement"). In this Agreement, you, the recipient of the license rights granted by this
                Agreement, are referred to as "Licensee" or "You." Any person who uses your Account is also a
                Licensee under this Agreement.</p>

            <h3>License Grant</h3>
            <p>Pursuant to the terms and conditions of this Agreement, Licensor grants Licensee a non-exclusive,
                non-transferable license ("License") to use the products, systems, and applications you are
                accessing, using, downloading, or streaming while signed in to this Account (the "Products") solely
                for Licensee's internal operations.</p>

            <h3>Use Restrictions</h3>
            <p>Except as explicitly provided herein, Licensee shall not: (1) make available nor distribute all or
                part of the Products to any third party by assignment, sublicense or by any other means; or (2)
                copy, adapt, reverse engineer, decompile, disassemble, or modify, in whole or in part, any of the
                Products.</p>

            <h3>Proprietary Rights</h3>
            <p>Licensee acknowledges and agrees that the copyright, patent, trade secret, and all other intellectual
                property rights of whatever nature in the Products are and shall remain the property of Licensor,
                and nothing in this Agreement should be construed as transferring any aspects of such rights to
                Licensee or any third party. This section survives License termination.</p>

            <h3>Licensee Data</h3>
            <p>Any data, including fusion joint data, imported by Licensee into this Account will remain the
                property of Licensee. Licensor makes no warranty or representation with respect to the accuracy of
                such data, or the property or equipment to which it relates. Licensor will maintain policies in
                conformity with industry standards to retain and backup such data, but Licensor shall bear no
                responsibility for the loss of such data. While the Products may be used alongside such data, the
                Products are not a substitute for maintenance and inspection of Licensee's property.</p>

            <h3>No Warranty</h3>
            <p>Licensor provides the products "as is" and makes no warranty or representation, either express or
                implied, with respect to the products, including, without limitation, any warranty related to the
                design or condition of the products. Licensor hereby expressly disclaims any implied warranty of
                merchantability, fitness for a particular purpose, title or noninfringement.</p>

            <h3>Indemnity</h3>
            <p>Licensee shall defend, indemnify and hold harmless Licensor (including, without limitation,
                Licensor's affiliates, directors, officers, and employees) from any loss, damage, claim of damage,
                liability or expense to any person or property (whether based on contract, tort, negligence or
                otherwise), including but not limited to reasonable attorneys fees, arising directly or indirectly
                out of (i) the acts or omissions of either Licensee, its agents, employees, clients or contractors,
                (ii) the failure of either Licensee, its agents, employees, clients or contractors to comply with
                this Agreement and (iii) any claim by an agent, employee, client or contractor of Licensee, other
                than due to the gross negligence or willful misconduct of Licensor.</p>

            <h3>Limitation of Liability</h3>
            <p>Licensor shall have no liability with respect to its obligations under this agreement or otherwise
                for consequential, exemplary, special, incidental or punitive damages even if it has been advised of
                the possibility of such damages. In any event, the liability of licensor to licensee for any reason
                and upon any cause of action shall be limited to the amounts paid by licensee to licensor for the
                products. The limitation applies to all causes of action in the aggregate, including without
                limitation to breach of contract, breach of warranty, negligence, strict liability,
                misrepresentations, and other torts. Both parties understand and agree that the remedies and
                limitations herein allocate the risks of product and service nonconformity between the parties as
                authorized by the uniform commercial code and of other applicable laws.</p>

            <h3>Term and Termination</h3>
            <p>The License granted herein shall remain in effect perpetually unless terminated as provided in this
                Agreement. Licensor may terminate this Agreement and the License, without prejudice to any other
                remedy Licensor may have, immediately without further obligation to Licensee, in the event of any
                breach by Licensee of this Agreement which is not remedied within thirty (30) days of Licensor's
                notice to Licensee of the breach and Licensor's intent to terminate the License.</p>

            <p>Upon termination of this Agreement, Licensee shall cease using the Products and promptly return or
                delete all copies of any Products residing in, on or off-line computer memory.</p>

            <h3>Miscellaneous</h3>
            <p>Unless Licensee is an employee of Licensor, the parties are independent contractors and neither party
                is an agent, representative, or partner of the other. This License may be modified only in writing
                signed by both parties. This License will be interpreted and enforced under Oklahoma law without
                regard to its conflict of law principles. If any provision of the License is found to be
                unenforceable, the remaining provisions of the License will continue in full force and effect as if
                the unenforceable portion did not exist.</p>

            <p>Licensee acknowledges that it has read and understands this agreement and agrees to be bound by its
                terms and conditions. Licensee further agrees that this agreement is the complete and exclusive
                statement of the agreement between licensee and licensor, and supersedes any proposal or prior
                agreement, oral or written, and any other communications relating to the products and the subject
                matter of this agreement.
            </p>
            <Button to="/" variant="contained">OK</Button>
        </CardPage>
    )
}